<template>
    <div v-if="items.length === 0">
        {{noInitialsText}}
    </div>
    <div v-else>
        <report-specialist v-for="item in items" :key="item.id" :data="item"/>
    </div>
</template>

<script>
    import ReportSpecialist from './ReportSpecialist'
    export default {
        name: 'ReportSpecialistList',
        props: {
            items: Array,
            noInitialsText: {
                type: String,
                default: '-'
            }
        },
        components: {
            ReportSpecialist
        }
    }
</script>

<style scoped>

</style>